import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import languages from '../../constants/DefaultLang';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from 'reactstrap';
import { isExternalURL, is_Preview, parseSanitizedHTML, forceToArray } from '../../utils/Helper';

import config from '../../config';
import './LangSwitcherDropdown.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const LangSwitcherDropdown = (props) => {
  const { i18n, siteConfig } = props;
  const curLang = i18n.locale;
  const { data = {} } = siteConfig || {};
  const { menu_config = {} } = data[i18n.locale] || {};
  const { availableLanguages } = data;
  // const [clickCloseDropdown, setClickCloseDropdown] = useState(false);

  // const toggle = () => {
  //   setDropdownOpen(!dropdownOpen);
  // };

  // const isOpen = () => {
  //   setDropdownOpen(true);

  //   const icon = document.querySelector('.langswitcher-icon');
  //   icon.classList.add('rotate');
  //   icon.classList.remove('rotate-back');
  // };

  // const notOpen = () => {
  //   setDropdownOpen(false);

  //   const icon = document.querySelector('.langswitcher-icon');
  //   icon.classList.add('rotate-back');
  //   icon.classList.remove('rotate');
  // };

  const html = Object.keys(languages || {}).map((v, i) => {
    if (v !== curLang && availableLanguages.indexOf(v) > -1) {
      const constructURL = (location) => {
        const curRootPath = `${config.routePathTo}/${curLang}`;
        const pathname =
          location.pathname === curRootPath ||
          location.pathname === config.routePathTo ||
          location.pathname === `${config.routePathTo}/`
            ? `${config.routePathTo}/${v}`
            : location.pathname.replace(curRootPath, `${config.routePathTo}/${v}`);
        return {
          ...location,
          pathname,
        };
      };
      return (
        <NavLink
          to={constructURL}
          key={i}
          activeClassName="selected"
          // onClick={()=> {
          //   setClickCloseDropdown(true);
          // }}
          className="nav-link"
        >
          {parseSanitizedHTML(languages[v].short)}
        </NavLink>
      );
    }
    return '';
  });

  console.log(isEmpty(menu_config));
  return (
    <>
      <UncontrolledDropdown
        // isOpen={dropdownOpen}
        // onMouseEnter={isOpen}
        // onMouseLeave={notOpen}
        // onMouseDown={isOpen}
        className="nav-item LangSwitcherDropdown"
        // toggle={toggle}
        isOpen={false}
      >
        <DropdownToggle
          data-toggle="dropdown"
          tag="span"
          // caret
          className="LangSwitcherDropdownToggle"
          // onMouseEnter={()=>{
          //   setClickCloseDropdown(false);
          // }}
          // onClick={()=>{
          //   setClickCloseDropdown(false);
          // }}
        >
          {languages[curLang].short}{' '}
          <FontAwesomeIcon icon={faChevronDown} className="langswitcher-icon" />
        </DropdownToggle>
        <DropdownMenu>{html}</DropdownMenu>
        {/*<DropdownMenu className={`${clickCloseDropdown ? 'click-close-dropdown' : ''}`}>{html}</DropdownMenu>*/}
      </UncontrolledDropdown>
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(LangSwitcherDropdown);

export { LangSwitcherDropdown as LangSwitcherDropdownComponent }; // <- For component Unit Test
export default connectStore;
